import React from "react";
import { NavLink } from "react-router-dom";
import { Row } from "react-bootstrap";
import DynamicTitle from "../../components/effects/DynamicTitle";
import ScrollToBottom from "../../components/effects/ScrollToBottom";
import OptimizedImageCarreDesktopBig from "../../components/divers/OptimizedImageCarreDesktopBig";
import OptimizedImageCarreDesktop from "../../components/divers/OptimizedImageCarreDesktop";
import OptimizedImageCarreMobile from "../../components/divers/OptimizedImageCarreMobile";

const Intro = () => {
  return (
    <Row className="intro position-relative" id="header_bg_home">
      <div className="header-home-text d-flex absolute flex-column align-items-start justify-content-center">
        <div className="align-items-center justify-content-center">
          <div className="col">
            <div className="question">
              Soyez visible, <br />
              là où vos clients
              <br className="d-sm-none d-md-flex d-lg-none" /> vous cherchent !
              <br />
              En étant
              <br className="d-sm-none d-md-flex d-lg-none" />
              <DynamicTitle />
            </div>
            {/* <div className="slogan">
          Attirez plus de clients, sans vous noyer dans la technique !
        </div> */}
            <p className="mt-3 mt-lg-5 service-text">
              Votre visibilité locale <b>dès 129€/mois</b> <br />
              sans contraintes techniques.
            </p>
            <div className="d-flex flex-row justify-content-evenly flex-wrap mt-5 cta-header-home">
              {/* <NavLink
                to="/offres/services-de-conception-de-site-web/"
                className="mt-4 my-lg-3 btn-decoration"
              >
                <div className="button-intro">
                  <div className="text-center z-3 btn-text">Créer mon site</div>
                </div>
              </NavLink> */}
              <NavLink
                to="/offres/services-de-referencement-de-site-web/"
                className="mt-4 my-lg-3 btn-decoration"
              >
                <div className="button-intro-bis">
                  <div className="text-center z-3 btn-text">
                    Booster mon SEO
                  </div>
                </div>
              </NavLink>
              <NavLink
                to="/offres/pack-site-seo/"
                className="mt-4 my-lg-3 btn-decoration"
              >
                <div className="button-intro">
                  <div className="text-center z-3 btn-text">
                    Opter pour le pack complet
                  </div>
                </div>
              </NavLink>
            </div>

            {/* <ButtonLiens
          buttonLink="/offres/services-web-seo/"
          buttonText="Lancez ma croissance locale"
          buttonClass="mt-5"
        /> */}
            {/* <div className="micro-preuves">99% de satisfactions clients</div> */}
          </div>
        </div>
      </div>
      <div className="header-home-photo"></div>
      {/* <div className="header-home-photo home-photo-mobile position-absolute bottom-0 align-items-end justify-content-end">
        <OptimizedImageCarreMobile
          src="/home/frantz-rouze-fondateur-de-fr-webdesign.webp"
          alt="Cette photo met en avant Frantz Rouzé, le créateur visionnaire derrière le studio FR Webdesign, un partenaire digital incontournable pour les entrepreneurs en quête de succès en ligne. Avec son approche personnalisée et son engagement sans faille, il vous aide à construire une présence digitale percutante, mettant en valeur votre entreprise et renforçant votre impact sur votre marché cible."
        />
      </div>
      <div className="header-home-photo home-photo-desktop position-absolute bottom-0 align-items-end justify-content-end">
        <OptimizedImageCarreDesktop
          src="/home/frantz-rouze-fondateur-de-fr-webdesign.webp"
          alt="Cette photo met en avant Frantz Rouzé, le créateur visionnaire derrière le studio FR Webdesign, un partenaire digital incontournable pour les entrepreneurs en quête de succès en ligne. Avec son approche personnalisée et son engagement sans faille, il vous aide à construire une présence digitale percutante, mettant en valeur votre entreprise et renforçant votre impact sur votre marché cible."
        />
      </div>
      <div className="header-home-photo home-photo-desktop-big position-absolute bottom-0 align-items-end justify-content-end">
        <OptimizedImageCarreDesktopBig
          src="/home/frantz-rouze-fondateur-de-fr-webdesign.webp"
          alt="Cette photo met en avant Frantz Rouzé, le créateur visionnaire derrière le studio FR Webdesign, un partenaire digital incontournable pour les entrepreneurs en quête de succès en ligne. Avec son approche personnalisée et son engagement sans faille, il vous aide à construire une présence digitale percutante, mettant en valeur votre entreprise et renforçant votre impact sur votre marché cible."
        />
      </div> */}

      <div className="scroll-to-bottom d-flex flex-column align-items-center justify-content-center">
        <ScrollToBottom />
      </div>
    </Row>
  );
};

export default Intro;
